
import React, { useState } from "react";
import { useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import A_Button from "../../../Atoms/Inputs/Buttons/A_Button";
import TextField from "@material-ui/core/TextField";
import ContactMail from "@material-ui/icons/ContactMail";
import A_SummerNote from "../../../Atoms/Inputs/SummerNote/A_SummerNote";
import "react-summernote/dist/react-summernote.css";
import { httpPost, httpPut } from "../../../../../Utils/apis/apis";
import { connect } from "react-redux";
import A_SimpleDialog from "../../../Atoms/Feedback/Dialogs/A_SimpleDialog";
import A_Snackbar from "../../../Atoms/Feedback/Snackbars/A_Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import { useParams } from "react-router";
import M_FormDropableFileUpload from "../../../Molecules/Common/File Upload/M_FormDropableFileUpload";
import { handleFileUpload } from "../../../Molecules/Common/File Upload/M_fileUpload.helper";
import A_Autocomplete from "../../../Atoms/Inputs/Autocompletes/A_Autocomplete";
import { Grid, Tooltip } from "@material-ui/core";
import A_MultiSelect from "../../../Atoms/Inputs/Selects/A_MultiSelect";
import { fieldType, ircConfig } from "../../../../../Utils/config/config";
import { emailPrefix } from "../IcEmail/email.helper";
import { Alert, AlertTitle } from "@material-ui/lab";
import { getObjectFromJSONString } from "../../../Molecules/Common/Navigations/AddEntity/M_ManageEntityForm.helper";
import RawHTMLRenderer from "../../../Atoms/RawHTMLRenderer/A_RawHTMLRenderer";
import { getDefaultuserList } from "./O_Mail.Helper";
import { getCRMContactInfo } from "../../../../../Utils/Helpers/common"
import PropTypes from "prop-types";
import { stageForSendICDisable } from "../MeetingSlotCard/A_ICDropdown";
import { addDateTimeWithFileName, currentEpochUTC, epochToDateFormatHelper } from "../../../../../Utils/Helpers/dateUtils";

const useStyles = makeStyles((theme) => ({
  inputLabel: {
    paddingRight: "1.2rem",
    fontWeight: "bold",
  },
  ircButton: {
    color: "#ffffff",
    backgroundColor: "#FFA500",
    textTransform: "none",
  },

  spanError: {
    color: "red",
    margin: "0",
    padding: "0 0 0 40px",
  },
  span: {
    color: "#ff6666",
  },
  btn: {
    width: "100%",
    display: "flex",
    justifyContent: "end",
  },
  formGroup: {
    margin: "1rem 0",
  },
  alertMobile: {
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      marginBottom: "30px",
      flexDirection: "column",
      alignItems: "center",
      textAlignLast: "center",
    },
  },
  Button: {
    marginRight: theme.spacing(1),
    marginTop: "6px",
    minWidth: "185px",
  },
  buttonWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "22px",
    marginRight: "15em",
  },
  errorMessage: {
    background: "rgb(253, 237, 237)",
    borderRadius: "4px",
    textAlign: "center",
    color: "rgb(102, 60, 0)",
    marginBottom: "1%",
    marginTop: "-2%",
    display: "flex",
    position: "fixed",
    left: "50%",
    transform: "translate(-50%,0%)",
    zIndex: "1",
  },
  sentMailErrorMessage: {
    background: "#ffe1e1",
    width: '100%',
    textAlign: "center",
    color: 'red',
    padding: '4px'
  },
  sentMailWarningMessage: {
    background: "#fcf8e3",
    width: '100%',
    textAlign: "center",
    color: '#b57f15',
    padding: '4px'
  }
}));

function IRC_Mail(props) {
  let { crmId, pageUrl } = useParams();
  let { content = {} } = props;
  const classes = useStyles();
  const user = useSelector((state) => state.oidc.user);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [files, setFiles] = React.useState([]);
  const [formData, setFormData] = React.useState(props.formData);
  const [remark, setRemark] = React.useState("");
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
  const [options, setOptions] = React.useState();
  const [showWarning, setShowWarning] = React.useState(false);
  const [isEmptyEmail, setIsEmptyEmail] = React.useState(false);
  const [EmailUsersOrg, setEmailUsersOrg] = React.useState({ toUser: [], ccUsers: [] });
  const [attachedMailError, setAttachedMailError] = React.useState(null);
  const [sizeError, setSizeError] = useState(null);
  const [changesSaved, setChangesSaved] = React.useState({
    status: false,
    type: "success",
    msg: "",
  });

  const loggedInUserData = useSelector(
    (state) =>
      state.oidc.user &&
      state.oidc.user.profile &&
      state.oidc.user.profile.email
  );

  let defaultDL = getObjectFromJSONString(
    props,
    ".content.defaultEmail.defaultDLName",
    ""
  );
  React.useEffect(() => {
    getOptionList();
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const defaultData = await getDefaultuserList(defaultDL, crmId);
      let toDefaultUsersData = toDefaultUsers({ ...content.emailList, defaultData })
      let ccDefaultUsersData = createLookUpJson({ ...content.emailList, defaultData });
      setEmailUsersOrg({ toUser: toDefaultUsersData, ccUsers: ccDefaultUsersData });
      setFormData({ ...formData, recipients: { data: [toDefaultUsersData], fieldType: "lookup" }, ccUsers: { data: ccDefaultUsersData } });
      setLoading(false);
    } catch {
      setLoading(false);
    }
  }

  function toDefaultUsers(data) {
    let label = data?.destinationVertex || "";
    let id = data?.defaultData?.[0]?.defaultToUser?.[0]?.crmId || null;
    let email = data?.defaultData?.[0]?.defaultToUser?.[0]?.email || "";

    return {
      id: id,
      label: label,
      title: email,
    };
  }

  const userDetails = useSelector((state) =>
    state &&
      state.getLoggedInUserReducer &&
      state.getLoggedInUserReducer.data &&
      state.getLoggedInUserReducer.data[0]
      ? state.getLoggedInUserReducer.data[0]
      : ""
  );
  function createLookUpJson(data) {
    let dealLeadData = data?.defaultData?.[0]?.dealLead?.map((item) => {
      return { crmId: item?.crmId, email: item?.email };
    }) || [];

    let dealTeamMembersData = data?.defaultData?.[0]?.dealTeamMembers?.map((item) => {
      return { crmId: item?.crmId, email: item?.email };
    }) || [];

    let { crmContactUserId, crmContactUserEmail } = getCRMContactInfo() || {};

    let id = userDetails?.id || crmContactUserId;
    let label = data?.destinationVertex || "";
    let email = userDetails?.properties?.email || crmContactUserEmail;

    const result = [];
    const uniqueDataSet = new Set();
    if (email?.includes("laing.com") && !uniqueDataSet.has(email)) {
      const uniqueKey = `${id}-${email}`;
      result.push({ id: id, label: label, title: email });
      uniqueDataSet.add(uniqueKey);
    }
    dealLeadData.forEach((data) => {
      const uniqueKey = `${data?.crmId}-${data?.email}`;
      if (!uniqueDataSet.has(uniqueKey)) {
        result.push({ id: data?.crmId, label: label, title: data?.email });
        uniqueDataSet.add(uniqueKey);
      }
    });

    dealTeamMembersData.forEach((member) => {
      const uniqueKey = `${member?.crmId}-${member?.email}`;
      if (!uniqueDataSet.has(uniqueKey)) {
        result.push({ id: member?.crmId, label: label, title: member?.email });
        uniqueDataSet.add(uniqueKey);
      }
    });
    return result;
  }


  const getOptionList = () => {
    const optionList =
      props.currentPage &&
        props.currentPage.pageConfig &&
        props.currentPage.pageConfig.optionSets &&
        Array.isArray(props.currentPage.pageConfig.optionSets) &&
        content.emailOptionSet
        ? props.currentPage.pageConfig.optionSets.filter(
          (optionSet) =>
            optionSet.optionSetName === content.emailOptionSet
        )
        : null;
    setOptions(optionList);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleSelect = (selectedValue, id) => {
    let newFormData = { ...formData };
    newFormData[id] = { data: selectedValue, fieldType: fieldType.OPTIONSET };
    setFormData(newFormData);
    setIsButtonDisabled(false);
  };
  const handleClose = () => {
    setShowWarning(true);
  };
  const handleLookup = (selectedValue, id) => {
    let newFormData = formData;
    selectedValue.data != ""
      ? (newFormData[id] = { ...selectedValue, fieldType: "lookup" })
      : (newFormData[id] = undefined);
    setFormData(newFormData);
    setIsButtonDisabled(false);
  };
  function subjectEmail(event) {
    let newFormData = { ...formData };
    newFormData["subject"] = event.target.value;
    setFormData(newFormData);
    setIsButtonDisabled(false);
  }
  function handleSummerNote(e) {
    setRemark(e);
    setIsButtonDisabled(false);
  }
  const handlePaste = (e) => {
    e.preventDefault();
    const clipboardData = e.clipboardData || window.Clipboard;
    const pastedContent = clipboardData.getData("text/plain");
    const processedContent = processPastedContent(pastedContent);
    const newContent = remark + processedContent;
    handleSummerNote(newContent);
  };
  const processPastedContent = (content) => {
    //  you can sanitize, format, or modify the pasted content
    return content;
  };
  const setFileData = (event, newFiles) => {
    event.preventDefault();
    if (newFiles.length == files.length) {
      setAttachedMailError(content.alreadyAttachedMessage || "The added file is already attached")
      setTimeout(() => setAttachedMailError(null), 5000);
    } else {
      setFiles(newFiles);
    }
    event.preventDefault();
  };
  React.useEffect(() => {
    if (
      (formData.subject !== "" ||
        formData.subject !== null ||
        formData.subject !== undefined) &&
      (formData.recipients !== "" ||
        formData.recipients !== null ||
        formData.recipients !== undefined) &&
      (remark !== "" || remark !== null || remark !== undefined)
    ) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  }, [formData]);

  const showResult = async () => {
    setIsButtonDisabled(true);

    const fileName = props.ircPortalData?.id + "/";
    let content = {
      containerType: "email",
      allowedExtensions: ["*"],
    };
    if (
      formData.subject == null ||
      formData.subject == undefined ||
      formData.subject == "" ||
      ((formData.recipients == null ||
        formData.recipients == undefined ||
        formData.recipients == "") &&
        getObjectFromJSONString(
          props,
          ".content.defaultEmail.isRequiredRecipients",
          true
        ) !== false) ||
      remark == null ||
      remark == undefined ||
      remark == ""
    ) {
      setIsEmptyEmail(true);
      setTimeout(() => {
        setIsEmptyEmail(false);
      }, 2000);
    } else {
      let filesData = [];
      let renamedFiles = files.map((file) => {
        let currentEpochTime = currentEpochUTC();
        let dateString = epochToDateFormatHelper(currentEpochTime, "YYYY-MM-DD HH:mm:ss")
        let newFileName = addDateTimeWithFileName(file, dateString)
        let newFile = new File([file], newFileName, {
          type: file.type,
          lastModified: file.lastModified
        });
        return newFile
      })
      for (let item in renamedFiles) {
        let filePath = emailPrefix + fileName + renamedFiles[item].name;
        filesData.push(filePath);
      }
      let toUsers = [];
      if (formData && formData.recipients) {
        if (formData.recipients.fieldType === fieldType.LOOKUP) {
          toUsers =
            formData && formData.recipients && formData.recipients.data
              ? formData.recipients.data.map((item) => item.title)
              : [];
        } else if (formData.recipients.fieldType === fieldType.OPTIONSET) {
          toUsers =
            formData && formData.recipients && formData.recipients.data
              ? formData.recipients.data.map((item) => item.value)
              : [];
        }
      }
      let ccUsers =
        formData && formData.ccUsers && formData.ccUsers.data
          ? formData.ccUsers.data.map((item) => item.title)
          : [];
      const data = {
        id: "",
        label: "ircemail",
        properties: {
          subject: formData.subject,
          sentBy: loggedInUserData,
          from: ircConfig.EMAIL,
          recipients: JSON.stringify(toUsers),
          remark: remark,
          ccUsers: JSON.stringify(ccUsers),
          attachGUID: props.ircPortalData?.id,
          isMailSent: false,
          responses: "[]",
          attachments: filesData.join(","),
        },
        edges: [],
        security: {
          read: {
            groupids: [],
            users: [],
          },
          update: {
            groupids: [],
            users: [],
          },
          full: {
            groupids: [],
            users: [],
          },
          privateRecord: true,
        },
      };
      let uploadedFile = 0;
      for (let item in renamedFiles) {
        await handleDocumentUploadAndDataSubmission(
          renamedFiles[item],
          fileName,
          content,
          uploadedFile,
          renamedFiles.length,
          data
        );
        uploadedFile += 1;
      }
      if (files.length === 0) {
        await handleMailService(data);
      }
      setIsButtonDisabled(false);
    }
  };

  const handleDocumentUploadAndDataSubmission = async (
    file,
    fileName,
    content,
    uploadedFileCount,
    uploadLength,
    data
  ) => {


    let droppedFiles = [{ files: [file] }];

    let genericContent = {
      allowedExtensions: ['*'],
      containerType: "generic"
    }
    let genericFileName = `${crmId}/`;

    let icPortalFileUpload = handleFileUpload(
      "",
      crmId,
      user,
      droppedFiles,
      content,
      fileName,
      "",
      ""
    );

    let genericFileUpload = handleFileUpload(
      "",
      crmId,
      user,
      droppedFiles,
      genericContent,
      genericFileName,
      "",
      ""
    );

    await Promise.all([icPortalFileUpload, genericFileUpload])
    if (uploadedFileCount >= uploadLength - 1) {
      await handleMailService(data);
    }
  };

  const handleMailService = async (payload) => {
    const response = await httpPost(
      `/CRMData/insert?pageUrl=${pageUrl}`,
      payload
    );

    if (response.id != null) {
      var addEdgePayload = {
        sourceVertexId: props.ircPortalData?.id,
        destinationVertexId: response.id,
        edgeLabel: "hasircemail",
      };
      await httpPut(`/CRMData/addEdge`, addEdgePayload);
      httpPut(`/DealChecklist/Complete/${crmId}`).then(() => {
        props.reload ? props.reload() : "";
      });
      setChangesSaved({
        status: true,
        type: "success",
        msg: "Mail Sent Successfully",
      });
    }
    // handleClose();
  };
  const handleSnackbarClose = () => {
    setChangesSaved({
      status: false,
      type: "",
      msg: "",
    });
  };

  let isChecklistCompleted = props.ircPortalData?.currentStatus && !stageForSendICDisable.includes(props.ircPortalData?.currentStatus) && !props.dealChecklistCompletion?.[props.ircPortalData?.currentStatus];

  return (
    <div>
      <Tooltip title={isChecklistCompleted && !loading ? content.sendICDocDisMessage : ""}>
        <div>
          <A_Button
            onClick={handleClickOpen}
            disabled={loading || isChecklistCompleted}
            label={loading || !props.ircPortalData?.currentStatus ? "Loading..." : props.label}
            className={classes.ircButton}
            icon={<ContactMail />}
          />
        </div>
      </Tooltip>
      <A_Snackbar
        open={changesSaved.status}
        message={changesSaved.msg}
        type={changesSaved.type}
        autoHideDuration={2000}
        vertical="bottom"
        horizontal="center"
        handleClose={handleSnackbarClose}
      />
      <A_SimpleDialog
        open={open}
        title="Email"
        height="110"
        maxWidth="sm"
        dialogContent={
          <div>
            {showWarning && (
              <Alert
                severity="warning"
                className={classes.alertMobile}
                action={
                  <div className={classes.buttonWrapper}>
                    <A_Button
                      label="Don't close form"
                      onClick={() => {
                        setShowWarning(false);
                      }}
                      className={classes.Button}
                      color="primary"
                      variant="outlined"
                    ></A_Button>
                    <A_Button
                      label="Close form anyway"
                      color="secondary"
                      onClick={() => {
                        setFormData({ recipients: { data: [EmailUsersOrg.toUser] }, ccUsers: { data: EmailUsersOrg.ccUsers } });
                        setShowWarning(false);
                        setOpen(false);
                        setFiles([]);
                      }}
                      className={classes.Button}
                      variant="outlined"
                    ></A_Button>
                  </div>
                }
              >
                <AlertTitle>Warning</AlertTitle>
                <strong>
                  Are you sure you want to close this form? You will lose
                  progress so far!
                </strong>
              </Alert>
            )}
            {isEmptyEmail && (
              <Alert severity="error" className={classes.errorMessage}>
                <strong>Please Fill Required Details</strong>
              </Alert>
            )}
            <Grid container alignItems="center">
              <Grid item xs="12">
                <span>
                  <RawHTMLRenderer
                    html={getObjectFromJSONString(
                      props,
                      ".content.defaultEmail.defaultLabel",
                      ""
                    )}
                  />
                </span>
              </Grid>
              <Grid item xs="12">
                {!options ? (
                  <A_Autocomplete
                    fullWidth={true}
                    size="medium"
                    entity={{}}
                    variant="standard"
                    className={classes.inputcontrol}
                    label={`To ${getObjectFromJSONString(
                      props,
                      ".content.defaultEmail.isRequiredRecipients",
                      ""
                    ) === false
                      ? ""
                      : "*"
                      }`}
                    onChange={handleLookup}
                    // {...elementProps}
                    multiple={true}
                    defaultValue={
                      formData && formData.recipients && formData.recipients.data
                        ? formData.recipients.data
                        : ""
                    }
                    id="recipients"
                    {...content.emailList}
                    lookupValuefilter={
                      content.lookupValuefilter
                    }
                  />
                ) : (
                  <A_MultiSelect
                    defaultValue=""
                    label="To *"
                    fullWidth={true}
                    onChange={handleSelect}
                    id="recipients"
                    multiple={true}
                    options={
                      options && options.length > 0 ? options[0].options : []
                    }
                  />
                )}
              </Grid>
              <Grid item xs="12">
                <A_Autocomplete
                  fullWidth={true}
                  size="medium"
                  entity={{}}
                  variant="standard"
                  className={classes.inputcontrol}
                  label={"CC "}
                  onChange={handleLookup}
                  // {...elementProps}
                  multiple={true}
                  id="ccUsers"
                  {...content.emailList}
                  defaultValue={
                    formData && formData.ccUsers && formData.ccUsers.data
                      ? formData.ccUsers.data
                      : ""
                  }
                  lookupValuefilter={
                    content.lookupValuefilter
                  }
                />
              </Grid>
              <Grid item xs="12">
                <TextField
                  className={classes.inputField}
                  id="standard-basic"
                  size="large"
                  label="Subject "
                  fullWidth={true}
                  placeholder=""
                  variant="standard"
                  onChange={subjectEmail}
                  value={formData.subject}
                  required
                />
              </Grid>
              <Grid item xs="12" className={classes.formGroup}>
                <A_SummerNote
                  label={"Request *"}
                  height="80"
                  onChange={handleSummerNote}
                  defaultValue={formData.remark}
                  disabled={false}
                  onPaste={handlePaste}
                ></A_SummerNote>
              </Grid>
              <Grid item xs="12" className={classes.formGroup}>
                <M_FormDropableFileUpload
                  files={files}
                  setFiles={setFileData}
                  comFileSizeAllowedInMB={content.comSizeLimit}
                  setComSizeError={setSizeError}
                  content={content}
                />
              </Grid>
              {attachedMailError &&
                <div className={classes.sentMailErrorMessage}>
                  {attachedMailError}
                </div>
              }
              <div className={sizeError ? classes.sentMailErrorMessage : classes.sentMailWarningMessage}>
                {content.fileSizeError}
              </div>
              <div className={`${classes.btn} ${classes.formGroup}`}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ float: "right" }}
                  type="button"
                  onClick={showResult}
                  disabled={isButtonDisabled}
                >
                  <span style={{ textTransform: "none" }}>Send Mail</span>
                </Button>
              </div>
            </Grid>
          </div>
        }
        onClose={handleClose}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    currentPage: state.currentPage,
    managePage: state.managePage,
    user: state.oidc.user.profile.email,
  };
}
IRC_Mail.propTypes = {
  content: PropTypes.object,
  formData: PropTypes.object,
  ircPortalData: PropTypes.string,
  dealChecklistCompletion: PropTypes.any,
  label: PropTypes.string,
  reload: PropTypes.func,
  currentPage: PropTypes.object,
};
export default connect(mapStateToProps)(IRC_Mail);
